import {
  ChangeDetectionStrategy,
  ChangeDetectorRef,
  Component,
  EventEmitter,
  Input,
  Output,
} from '@angular/core';

import { TranslateModule } from '@ngx-translate/core';

import { NgxSkeletonLoaderModule } from 'ngx-skeleton-loader';

import { ESvgIcons } from 'src/app/core/enums/svg-icons';

@Component({
  selector: 'app-filters-wrapper',
  templateUrl: 'filters-wrapper.component.html',
  styleUrls: ['filters-wrapper.component.scss'],
  imports: [NgxSkeletonLoaderModule, TranslateModule],
  changeDetection: ChangeDetectionStrategy.OnPush,
})
export class FiltersWrapperComponent {
  @Input() wrapperClass: string[] = [];
  @Input() openedMap: boolean = false;
  @Input() showFilterSection = true;
  @Output() onCloseMap: EventEmitter<void> = new EventEmitter<void>();
  @Output() onFiltersToggle: EventEmitter<boolean> =
    new EventEmitter<boolean>();
  public showFilters: boolean = true;

  public readonly eSvgIcons = ESvgIcons;

  constructor(private cdr: ChangeDetectorRef) {}

  toggleFilters() {
    this.showFilters = !this.showFilters;
    this.onFiltersToggle.emit(this.showFilters);
    this.cdr.markForCheck();
  }
}
